import React, { Component } from 'react';
import { element, bool, string, number, shape } from 'prop-types';
import { t } from 'i18next';
import { connect } from 'react-redux';

import { SHOPPING_CART_TARGET } from '~screens/Dashboard/screens/Home/redux/constants';
import { shoppingCartPropTypes } from '~screens/Dashboard/screens/Home/propTypes';
import { getItemUniqueId } from '~utils/menuItem';
import emptyCartImage from '~assets/ic_cart_empty.svg';
import { CURRENT_USER_TARGET } from '~redux/Auth/constants';

import { enablePromoSelling } from './components/PromoSelling/utils';
import CartVariant from './components/CartVariant';
import styles from './styles.module.scss';
import GiftCard from './components/GiftCard';
import FreeProduct from './components/FreeProduct';

class CartContent extends Component {
  // FIXME this logic is not wrong, but it is antipattern, should be changed in the future
  state = {
    loading: this.props.loading
  };

  cartRef = React.createRef();

  componentDidUpdate(prevProps) {
    const { shoppingCart } = this.props;

    if (shoppingCart.items.length > prevProps.shoppingCart.items.length) {
      const { current } = this.cartRef;

      current?.scrollTo({ top: current.scrollHeight, behavior: 'smooth' });
    }
  }

  render() {
    const {
      shoppingCart,
      emptyContent,
      className,
      totalPoints,
      showUpselling,
      showGiftCardDisclaimer,
      canModifyItems,
      currentUser,
      showFreeProduct,
      loyaltyExperienceEnabled,
      isCheckout
    } = this.props;

    return shoppingCart?.items.length > 0 ? (
      <>
        <div ref={this.cartRef} className={`item-1 column ${styles.cartVariantListContainer} ${className}`}>
          {(canModifyItems || isCheckout) && enablePromoSelling(isCheckout)}
          {shoppingCart.items.map((item, index) => {
            const CartComponent = item.isGiftCard ? GiftCard : CartVariant;
            return (
              <CartComponent
                key={getItemUniqueId(item, index)}
                item={item}
                loading={this.state.loading}
                totalPoints={totalPoints}
                index={index}
                canModifyItem={canModifyItems}
                showUpselling={showUpselling}
                showGiftCardDisclaimer={showGiftCardDisclaimer}
                isCheckout={isCheckout}
              />
            );
          })}
        </div>
        {!!currentUser && showFreeProduct && loyaltyExperienceEnabled && <FreeProduct />}
      </>
    ) : (
      <div className={`column ${styles.emptyState}`}>
        <img src={emptyCartImage} alt={t('Cart:emptyCartTitle')} className="m-bottom-6" />
        <div className={`text-highlighted m-bottom-1 text-center ${styles.emptyCartTitle}`}>
          {t('Cart:emptyCartTitle')}
        </div>
        {emptyContent}
      </div>
    );
  }
}

CartContent.propTypes = {
  shoppingCart: shoppingCartPropTypes.isRequired,
  canModifyItems: bool,
  className: string,
  currentUser: shape({}),
  emptyContent: element,
  isCheckout: bool,
  loading: bool,
  loyaltyExperienceEnabled: bool,
  showFreeProduct: bool,
  showGiftCardDisclaimer: bool,
  showUpselling: bool,
  totalPoints: number
};

CartContent.defaultProps = {
  canModifyItems: true,
  className: '',
  showFreeProduct: false,
  showGiftCardDisclaimer: false,
  showUpselling: false
};

const mapStateToProps = state => ({
  shoppingCart: state.home[SHOPPING_CART_TARGET],
  currentUser: state.auth[CURRENT_USER_TARGET],
  loyaltyExperienceEnabled: state.home.coreSettings?.loyaltyExperienceEnabled
});

export default connect(mapStateToProps, null)(CartContent);
